import api from '../index';

const contentSubmissionVersionUpdaters = {
  startAnalysis: async (contentSubmissionVersionId: string) => {
    return api.post(
      `/content_submission_versions/${contentSubmissionVersionId}/start_analysis`
    );
  },
};

export default contentSubmissionVersionUpdaters;
